// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.png";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
// import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
// import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
// import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import phpstorm from "./assets/techstack/phpstorm.png";
import php from "./assets/techstack/php.png";
import ts from "./assets/techstack/ts.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Bernardus Dwi Wahyu Dwianto",
  tagline: "",
  img: profile,
  about: `Sebagai lulusan Teknik Informatika, saya membawa sikap profesional yang tenang dan komitmen tinggi terhadap pekerjaan yang membutuhkan ketelitian. Saya dapat bekerja secara kolaboratif dalam tim atau secara mandiri yang membutuhkan fleksibilitas dan adaptabilitas yang kuat. Saya memiliki semangat untuk belajar dan mengembangkan diri, serta berkeinginan untuk memperluas jaringan relasi profesional.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/",
  github: "https://www.github.com/",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
    {
    Position: "Full Stack Developer",
    Company: `Universitas Santo Borromeus`,
    Location: "Bandung",
    Type: "Full Time",
    Duration: "Current",
  },
  {
    Position: "Full Stack Developer",
    Company: `Universitas Katolik Parahyangan`,
    Location: "Bandung",
    Type: "Full Time",
    Duration: "Jan 2024 - Mar 2025",
  },
  // {
  //   Position: "Internship",
  //   Company: `Company Name here`,
  //   Location: "Bengaluru",
  //   Type: "Internship",
  //   Duration: "Sep 2021 - Dec 2021",
  // },
  // {
  //   Position: "Internship",
  //   Company: `Company Name here`,
  //   Location: "Bengaluru",
  //   Type: "Internship",
  //   Duration: "Sep 2021 - Dec 2021",
  // },
];

// Enter your Education Details here
export const eduDetails = [ 
  {
    Position: "Sarjana Informatika",
    Company: `STMIK Likmi`,
    Location: "Bandung",
    Type: "",
    Duration: "2022",
  },
  {
    Position: "Sekolah Menengah Atas (SMA)",
    Company: `Santa Maria`,
    Location: "Cirebon",
    Type: "",
    Duration: "2017",
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  // redux: redux,
  // sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  // npm: npm,
  git: git,
  github: github,
  phpstorm: phpstorm,
  php: php,
  ts: ts,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "Ekstrak Data (SI Aku Hadir)",
    image: projectImage1,
    description: `Aku Hadir merupakan aplikasi yang digunakan untuk pengelolaan data presensi dan absensi pegawai.`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Expo",
    image: projectImage2,
    description: `Expo merupakan aplikasi yang digunakan pada saat kegiatan Expo / Job Fair. 
    Aplikasi ini digunakan oleh mahasiswa atau tamu perusahaan yang sudah mendaftar sebagai peserta 
    Expo / Job Fair untuk mengisi data diri yang nantinya akan bisa dilihat oleh perusahaan-perusahaan 
    terkait.`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "SI Kepres / Kepresma",
    image: projectImage3,
    description: `SiKepres / Kepresma merupakan aplikasi yang digunakan oleh mahasiswa untuk pengelolaan organisasi, kegiatan
    organisasi, dan data pencapaian mahasiswa.`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Duplikat Konfig (SiPenamas)",
    image: projectImage4,
    description: `SiPenamas merupakan aplikasi yang digunakan oleh dosen pengelolaan sejumlah program yang
    memberi pengaruh terhadap sosial`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Perubahan Status (Stupor, Lectpor, Siakad)",
    image: projectImage5,
    description: `Merupakan aplikasi yang digunakan oleh dosen pengelolaan sejumlah program yang
    memberi pengaruh terhadap sosial`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "SI Rekat",
    image: projectImage6,
    description: `Merupakan aplikasi yang digunakan oleh dosen dan tenaga kependidikan untuk melakukan
  pengajuan proposal kegiatan yang akan diselengarakan. Selanjutnya proposal tersebut akan
  diperiksa, dinilai dan diputuskan (setuju/tolak) di tahap selanjutnya.`,
    techstack: "PHP, HTML/CSS, JavaScript",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  }
];

// Enter your Contact Details here
export const contactDetails = {
  email: "phase08dwiwahyu@gmail.com",
  phone: "+62877 2957 1199",
};
